import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import AsyncSelect from 'react-select/lib/Async';
import Modal from '../../containers/common/Modal';
import StyledTappable from '../common/StyledTappable';
import { RegularText, Text, BoldText } from '../common/Text';
import { FaTimes } from 'react-icons/fa';
import { PrimaryButton } from '../common/Buttons';
import { getLabTests } from '../../services';

const ModalContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
`;

const ModalBody = styled.div`
  display: flex;
  flex: 1;
  max-width: 70%;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 1.125rem 1.25rem 1.875rem 1.25rem;
  border-radius: 0.5rem;
  margin: 0 1rem;
  text-align: center;
`;

const ButtonComponent = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 1.625rem;
  align-items: center;
  justify-content: space-between;
`;

const Button = styled(PrimaryButton)`
  margin-left: 0.625rem;
  /* width: 6rem; */
  margin-top: 1.625rem;
`;

const ButtonText = styled(BoldText)`
  color: white;
  font-size: 1.5rem;
  padding: 0.625rem 1.625rem;
  /* text-transform: uppercase; */
  text-align: center;
`;

const ModalHeader = styled.div`
  display: flex;
  align-self: stretch;
  align-items: center;
  justify-content: space-between;
  padding: 0rem 1.25rem 1.875rem 1.25rem;
`;

const HeaderText = styled(BoldText)`
  font-size: 2rem;
`;

const ButtonsComponent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Body = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  /* border: 4mm solid rgb(170, 50, 20, 0.6); */
  flex-direction: column;
`;

const AgeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
  flex: 1;
`;

const LabelText = styled(Text)`
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #000;
  display: flex;
  flex-direction: row;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1.625rem 0.625rem;
`;

const AddedTestsContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  /* box-shadow: 0 -0.3rem 0.625rem 0 rgba(0, 0, 0, 0.09); */
  padding: 0.625rem 1rem;
  margin-bottom: 2.5rem;
  background: white;
  flex-shrink: 0;
`;

const AddedTestsInnerContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.75rem;
`;

const AddedTestContainer = styled(StyledTappable)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-right: 0.5rem;
  background: #f4f4f4;
  box-shadow: 0 0.375rem 0.625rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 2rem;
  padding: 0.5rem 1rem;
`;

const RemoveIcon = styled(FaTimes)`
  margin-left: 1.125rem;
`;

const LabText = styled(RegularText)`
  font-size: 1.6rem;
`;

const customStyles = {
  option: (provided) => ({
    ...provided,
    padding: 10,
    fontSize: 16,
    textAlign: 'left',
  }),
  placeholder: (provided) => ({
    ...provided,
    // padding: 10,
    fontSize: 12,
    textAlign: 'left',
  }),
  valueContainer: (provided) => ({
    ...provided,
    // padding: 10,
    fontSize: 14,
    textAlign: 'left',
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    padding: 10,
    fontSize: 14,
    textAlign: 'left',
  }),
};

class AddLabTestsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastLabs: [],
    };

    this.labTestSelectRef = React.createRef();
  }

  getLabs = (input) => {
    return getLabTests(this.props.authToken, input)
      .then((result) => {
        console.log({ result }, 'getLabs result');
        result.forEach((lab) => {
          console.log({ lab });
          lab.label = lab.name;
          lab.value = lab.name;
        });
        this.setState({ lastLabs: result });
        return result;
      })
      .catch((err) => {
        console.log({ err });
        return [];
      });
  };

  promiseOptions = (input) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.getLabs(input.toLowerCase()));
      }, 500);
    });
  };

  onLabSelect = (option, cb) => {
    console.log({ option, cb, ref: this.labTestSelectRef.current });
    // const labTests = [{...option}].concat(this.state.addedLabs);

    if (option) {
      this.props.addLabTest(option);
    } else {
      this.labTestSelectRef.current.state.defaultOptions = null;
    }
  };

  onFocus = (focus) => {
    console.log({ focus });
  };

  renderSelection = (ele) => (
    <AddedTestContainer
      key={ele.name}
      onTap={() => this.props.removeLabTest(ele)}
    >
      <LabText>{ele.name}</LabText>
      <RemoveIcon />
    </AddedTestContainer>
  );

  render() {
    return (
      <Modal>
        <ModalContainer>
          <ModalBody>
            <ModalHeader>
              <HeaderText>Add Lab Tests</HeaderText>
              <ButtonsComponent>
                <ButtonComponent>
                  <Button
                    onTap={this.props.hideModal}
                    // loading={this.state.loading}
                  >
                    <ButtonText>Done</ButtonText>
                  </Button>
                </ButtonComponent>
                {/* <CloseContainer onTap={this.props.hideModal}>
                  <CrossIcon />
                </CloseContainer> */}
              </ButtonsComponent>
            </ModalHeader>

            <Body>
              <InputContainer>
                <AgeContainer>
                  <LabelText>Add Lab Tests</LabelText>
                  <AsyncSelect
                    ref={this.labTestSelectRef}
                    styles={customStyles}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary50: '#d5d5d5',
                        primary25: '#f5f5f5',
                        primary: '#8852cc',
                      },
                    })}
                    placeholder="Search Lab Test"
                    cacheOptions
                    isClearable={true}
                    onFocus={(focus) => this.onFocus(focus)}
                    // isMulti
                    defaultOptions={this.state.lastLabs}
                    loadOptions={this.promiseOptions}
                    onChange={(option, cb) => this.onLabSelect(option, cb)}
                  />
                </AgeContainer>
              </InputContainer>
              <AddedTestsContainer>
                <AddedTestsInnerContainer>
                  {this.props.labTests.map(this.renderSelection)}
                </AddedTestsInnerContainer>
              </AddedTestsContainer>
            </Body>
          </ModalBody>
        </ModalContainer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  labTests: state.prescription.labTests,
});

export default connect(mapStateToProps)(AddLabTestsModal);
